'use client';

import { useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/Icon';
import { getProductIdFromHandle } from '../../utils';
import styles from './reviewStarRating.module.scss';
import { useOkendoReviews } from './reviewUtils';
interface OkendoStarRatingProps {
  onClick: () => void;
  productHandle: string;
  showArrow?: boolean;
  showAverageRating?: boolean;
}
export function ReviewStarRating({
  onClick,
  productHandle,
  showArrow = true,
  showAverageRating = false
}: OkendoStarRatingProps) {
  const widgetContainer = useRef(null);
  const [productId, setProductId] = useState<string | undefined>();
  const {
    reviewCount,
    averageRating
  } = useOkendoReviews(widgetContainer, productId);
  useEffect(() => {
    if (productHandle) {
      getProductIdFromHandle(productHandle).then(id => {
        setProductId(id);
      });
    }
  }, [productHandle]);

  // TODO this widget doesn't quite match the designs for accessory redesign, but okendo doesn't support having multiple versions of the widget used at one time
  return productId ? <div className={clsx('relative flex flex-row items-center', !reviewCount ? styles.hide : '')} data-sentry-component="ReviewStarRating" data-sentry-source-file="ReviewStarRating.tsx">
      <button aria-label='reviews-button' className={clsx(styles.clickable, 'text-sm')} onClick={onClick} type='button' />
      {showAverageRating && reviewCount > 0 && averageRating > 0 ? <span className={styles.averageRating}>{averageRating}</span> : null}
      <div className={styles.autoCursor} data-oke-reviews-product-id={`shopify-${productId}`} data-oke-star-rating data-testid={`shopify-${productId}`} id={`shopify-${productId}`} ref={widgetContainer} style={{
      lineHeight: '0'
    }} />
      {reviewCount && showArrow ? <div className='flex items-center pl-2 text-sm'>
          <Icon alt='arrow right open reviews modal' size='small' variant='arrow_right' />
        </div> : null}
    </div> : null;
}